"use client";
// Fixed bottom bar listing every landing-page variation, mounted identically
// on all of them (page.tsx + page-v0..v6). Self-scoped styling — deliberately
// does not read each host page's design tokens, so it looks and behaves the
// same regardless of which variation it's sitting on top of.

import { Moon, Sun } from "lucide-react";
import Link from "next/link";

import styles from "./design-variations-bar.module.css";

import { IconButton } from "@/components/ui";
import { useTheme } from "@/hooks/useTheme";
import { applyTheme } from "@/lib/theme";

const VARIATIONS = [
  { id: "ai-os", label: "AI-OS", href: "/" },
  { id: "v0", label: "V0 · Original", href: "/preview/v0" },
  { id: "v1", label: "V1 · Meridian", href: "/preview/v1" },
  { id: "v2", label: "V2 · Obsidian", href: "/preview/v2" },
  { id: "v3", label: "V3 · Signal", href: "/preview/v3" },
  { id: "v4", label: "V4 · Chalk", href: "/preview/v4" },
  { id: "v5", label: "V5 · Atlas", href: "/preview/v5" },
  { id: "v6", label: "V6 · Scalpel", href: "/preview/v6" },
] as const;

export function DesignVariationsBar({
  current,
}: {
  current: (typeof VARIATIONS)[number]["id"];
}) {
  const { theme } = useTheme();
  const light = theme === "paper" || theme === "light";

  return (
    <div className={styles.bar}>
      <div className={styles.left}>
        <span className={styles.label}>Design Variations</span>
        <nav className={styles.links}>
          {VARIATIONS.map((v) =>
            v.id === current ? (
              <span key={v.id} className={styles.current}>
                {v.label} (current)
              </span>
            ) : (
              <Link key={v.id} href={v.href} className={styles.link}>
                {v.label}
              </Link>
            ),
          )}
        </nav>
      </div>
      <IconButton
        size="sm"
        className={styles.themeToggle}
        aria-label={light ? "Switch to dark mode" : "Switch to light mode"}
        onClick={() => applyTheme(light ? "clinical" : "paper")}
      >
        {light ? <Moon size={15} /> : <Sun size={15} />}
      </IconButton>
    </div>
  );
}
